import { gql, useQuery } from '@apollo/client'
import React, { useEffect, useState } from 'react'

import CustomerDeleteButton from '../../components/customer/delete-button'
import CustomerModal from '../../components/customer/modal'
import MomentDate from '../../components/date'
import Pagination from '../../components/pagination'
import Table from '../../components/table'
import Title from '../../components/title'

const CUSTOMERS_QUERY = gql`
  query CustomersQuery($limit: Int, $skip: Int) {
    customers(limit: $limit, skip: $skip) {
      id
      email
      firstname
      lastname
      createdAt
    }
  }
`

const CUSTOMERS_SEARCH_QUERY = gql`
  query CustomersSearchQuery($query: String!) {
    customers: searchCustomers(query: $query) {
      id
      email
      firstname
      lastname
      createdAt
    }
  }
`

const Customers = () => {
  const limit = 50
  const [page, setPage] = useState(1)
  const skip = limit * (page - 1)
  const [searchQuery, setSearchQuery] = useState('')

  const query = searchQuery === '' ? CUSTOMERS_QUERY : CUSTOMERS_SEARCH_QUERY
  const { loading, error, data, refetch } = useQuery(query, {
    variables: { limit, skip, query: searchQuery },
    fetchPolicy: 'network-only',
  })

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [page, loading])

  const customers = data?.customers || []

  return (
    <div>
      <Title>Kunden</Title>
      <Table
        searchable
        searchQuery={searchQuery}
        onSearchInputChange={setSearchQuery}
        searchInputPlaceholder="Suchbegriff eingeben. Bspw: Name, E-Mail oder Kunden-ID"
        loading={loading}
        error={error}
        columns={[
          { label: 'ID', className: 'font-semibold text-gray-900' },
          { label: 'Name' },
          { label: 'E-Mail' },
          { label: 'Registriert am' },
          { label: 'Aktionen' },
        ]}
        items={customers}
        renderItem={(customer) => {
          return [
            { content: customer.id },
            {
              content: (
                <CustomerModal
                  id={customer.id}
                  buttonLabel={`${customer.firstname} ${customer.lastname}`}
                  buttonClassName="text-gray-500 hover:underline"
                />
              ),
            },
            { content: customer.email },
            { content: <MomentDate date={customer.createdAt} /> },
            {
              content: (
                <CustomerDeleteButton
                  customerId={customer.id}
                  onDeleted={() => refetch()}
                />
              ),
            },
          ]
        }}
      />
      {searchQuery === '' && customers.length === limit && (
        <Pagination
          page={page}
          lastPage={customers.length < limit}
          setPage={setPage}
        />
      )}
    </div>
  )
}

export default Customers
